const toCamelCase = (str) => str.replace(/([-_][a-z])/gi, ($1) => $1.toUpperCase().replace("-", "").replace("_", ""));

const toSnakeCase = (str) => str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

const isArray = (array) => Array.isArray(array);

const isObject = (obj) => typeof obj === "object" && !isArray(obj) && obj !== null;

const convertObjectKeysTo = (obj, conversionFunc) => {
   if (isObject(obj)) {
      const result = {};

      Object.keys(obj).forEach((key) => {
         result[conversionFunc(key)] = convertObjectKeysTo(obj[key], conversionFunc);
      });

      return result;
   }

   if (isArray(obj)) {
      return obj.map((str) => convertObjectKeysTo(str, conversionFunc));
   }

   return obj;
};

const keysToCamel = (obj) => {
   return convertObjectKeysTo(obj, toCamelCase);
};

// IMPORTANT: We should limit the use of this function and do this conversion manually if possible, to avoid cases
// where it's not possible to convert from snake to camel and back to snake without loosing info.
// Example: 'user_ID' > 'userID' > 'user_i_d'
const keysToSnake = (obj) => {
   return convertObjectKeysTo(obj, toSnakeCase);
};

export { keysToCamel, keysToSnake, toSnakeCase, toCamelCase };
